const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_VARIANT)
const groupPrefix2 = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_VARIANTS)

export const apiMealVariant = {
	fetchDietMealVariant: async (variant: number) => {
		const { data } = await apiCommon<IDietMealVariant>(`${groupPrefix}/${variant}`, {
			method: 'GET',
			...createQuery(),
		})
		return { data: DietMealVariant(data) }
	},

	fetchDietMealVariantsV2: async (ids?: number[], names?: string[], excludedIDs?: number[]) => {
		const { data } = await apiCommon<IDietMealVariant[]>(groupPrefix2, {
			method: 'GET',
			...createQuery(undefined, { id: ids, name: names, excluded_ids: excludedIDs }),
		})
		return data.map(DietMealVariant)
	},
}
